// extracted by mini-css-extract-plugin
export default {"hr-desktop":"AppWrapper-module__hr-desktop__vdhyr","hr-mobile":"AppWrapper-module__hr-mobile___z79H"};